export default __webpack_public_path__ + "static/media/truck_blue.4b5b50da.svg";